import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { TextInputField } from '@repo/ui/Form';
import { registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

import React from 'react';
import { useFormState } from 'react-hook-form';

const UsersTableFilter = () => {
  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }
  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="First name" {...registerInput(filter, 'first_name')} />
        <TextInputField label="Last name" {...registerInput(filter, 'last_name')} />
        <TextInputField label="Email" {...registerInput(filter, 'email')} />
      </TableFilterSection>

      <TableFilterButtons className="self-end" />
    </TableFilterCard>
  );
};

export default UsersTableFilter;
